import React from 'react';
import { Text } from '@consta/uikit/Text';
import { Button } from '@consta/uikit/Button';

// Styles
import cn from 'classnames/bind';
import styles from './styles.styl';

const cx = cn.bind(styles);

export interface CloseModalProps {
  setModalOpenBlocking: (item: boolean) => void;
  handleClick: () => void;
  title: string;
  text: string;
  textButton: string;
  iconClose: any;
}

export const CloseModal: React.FC<CloseModalProps> = ({
  setModalOpenBlocking,
  handleClick = () => {},
  title,
  text,
  textButton,
  iconClose,
}) => {
  return (
    <div className={cx('CloseModal')}>
      <div className={cx('CloseModal__row')}>
        <Text size="m">{title}</Text>
        <Button
          onClick={() => {
            setModalOpenBlocking(false);
          }}
          className={cx('CloseModal__button')}
          size="s"
          view="clear"
          iconRight={iconClose}
          onlyIcon
        />
      </div>
      <Text className={cx('CloseModal__text')} size="m">
        {text}
      </Text>
      <div className={cx('CloseModal__save')}>
        <Button
          onClick={() => {
            setModalOpenBlocking(false);
          }}
          label="Отмена"
          size="m"
          view="ghost"
          className={cx('CloseModal__buttonSave')}
        />
        <Button onClick={() => handleClick()} size="m" label={textButton} />
      </div>
    </div>
  );
};
